"use client"

import React, { useState } from "react"
import { GeneralSpecification, Unit } from "@/@types"
import { cn } from "@/lib/utils"

type EspecificacionesProps = {
  generalSpecifications: GeneralSpecification[]
}

export default function ProductGeneralSpec({ generalSpecifications }: EspecificacionesProps) {
  const [activeTab, setActiveTab] = useState<"EE.UU" | "MÉTRICAS">("EE.UU")

  return (
    <div>
      {/* Contenedor de pestañas */}
      <div className="inline-flex items-center rounded-md overflow-hidden mb-4">
        {/* Pestaña EE.UU */}
        <button
          onClick={() => setActiveTab("EE.UU")}
          className={cn(
            "px-4 py-2 text-sm font-bold uppercase leading-4 transition-colors duration-200 focus:outline-none appearance-none rounded-l border border-dark02 w-[101.8px] h-[28.86px] justify-center items-center flex",
            activeTab === "EE.UU"
              ? "bg-dark02 text-white"
              : "bg-light01 text-dark02"
          )}
        >
          EE.UU
        </button>

        {/* Pestaña MÉTRICAS */}
        <button
          onClick={() => setActiveTab("MÉTRICAS")}
          className={cn(
            "px-4 py-2 text-sm font-bold uppercase leading-4 transition-colors duration-200 focus:outline-none appearance-none rounded-r border border-dark02 w-[101.8px] h-[28.86px] justify-center items-center flex",
            activeTab === "MÉTRICAS"
              ? "bg-dark02 text-white"
              : "bg-light01 text-dark02"
          )}
        >
          MÉTRICAS
        </button>
      </div>

      {/* Listado de especificaciones o mensaje de sin información */}
      <div className="bg-light00">
        {/* Si `generalSpecifications` es null/undefined o está vacío, muestra "Sin información" */}
        {!generalSpecifications || generalSpecifications.length === 0 ? (
          <p className="text-center py-4">Sin información</p>
        ) : (
          generalSpecifications.map((spec) => {
            // Filtra la unidad adecuada según la pestaña activa
            const unit = spec.units.find((u: Unit) =>
              activeTab === "EE.UU"
                ? u.measurement_type_name === "English"
                : u.measurement_type_name === "Metric"
            )

            if (!unit) return null

            return (
              <div
                key={spec.rubro_specification_id}
                className="flex justify-between items-center border-b border-gray-200 p-2"
              >
                {/* Nombre de la especificación (columna izquierda) */}
                <span className="text-gray03">{spec.specification_name}</span>

                {/* Valor y unidad (columna derecha) */}
                <span className="font-bold text-dark01">
                  {unit.value} {unit.unit}
                </span>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}